import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectEnabledUsers = createSelector(
  [
    (store: RootState) => store.massiveDocumentCreate.userRole,
    (store: RootState) => store.massiveDocumentCreate.selectedUsers,
    (store: RootState) => store.massiveDocumentCreate.searchText,
    (store: RootState) => store.massiveDocumentCreate.createFilters,
    (store: RootState) => store.massiveDocumentCreate.locations,
    (store: RootState) => store.userAuthentication.user?.sourceOrganization,
  ],
  (userRoles, selectedUsers, searchText, createFilters, stateLocations, authUserSourceOrganization) =>
    userRoles?.filter(
      ({ code, user: { isSignatureEnabled, nameNormalized, id, dni }, organization, sourceOrganization, location }) => {
        if (code === "Sup. Responsable") {
          return false;
        }
        if (!isSignatureEnabled) {
          return false;
        }
        if (selectedUsers.find(({ user: { id: selectedUserId } }) => selectedUserId === id)) {
          return false;
        }
        if (sourceOrganization?.id != authUserSourceOrganization) {
          return false;
        }
        if (createFilters.organization.id && organization?.id !== createFilters.organization.id) {
          return false;
        }
        if (
          searchText &&
          !nameNormalized?.toLowerCase().includes(searchText?.toLowerCase().trim()) &&
          !dni?.split("-").join("").split(".").join("").trim().includes(searchText.trim())
        ) {
          return false;
        }

        if (
          createFilters.location.id &&
          !stateLocations
            .filter(({ partOf }) => partOf)
            .filter(({ partOf }) => partOf.id === createFilters.location.id)
            .find(({ id }) => id === location?.id)
        ) {
          return false;
        }

        if (createFilters.range) {
          let count: number[] = [];
          let hyphenSplit: string[][] = [];
          const commaSplit = createFilters.range.split(",");
          commaSplit.forEach((t) => hyphenSplit.push(t.split("-")));
          hyphenSplit.forEach((item) => {
            for (let index = +item[0]; index <= +item[1]; index++) {
              count.push(index);
            }
          });

          if (
            (createFilters.location.id || createFilters.organization.id) &&
            location?.code &&
            !count.includes(+location?.code.substring(location.code.length - 3))
          ) {
            return false;
          }
        }
        return true;
      }
    ) || []
);
